export const state = () => ({
  users: [],
  noMoreUsers: false,
  searchVersion: 0
})

export const mutations = {
  START_SEARCH (state) {
    state.searchVersion++
    state.noMoreUsers = false
  },
  SET_USERS (state, users) {
    state.users = users
  },
  ADD_USER (state, user) {
    if (!state.users.some(existing => existing.id == user.id)) state.users.push(user)
  },
  REMOVE_USER (state, id) {
    if (state.users) {
      const index = state.users.findIndex(user => user.id == id)
      if (index !== -1) state.users.splice(index, 1)
    }
  },
  SET_NO_MORE_USERS (state, noMoreUsers) {
    state.noMoreUsers = noMoreUsers
  }
}

// The backend keeps these profiles on the list unless asked otherwise, so the parameter only
// travels once the viewer has switched the filter off.
function searchQuery (searchParameters) {
  const query = {
    radius: searchParameters.radius,
    place_id: searchParameters.city.place_id,
    place_main: searchParameters.city.main,
    city: searchParameters.city.description
  }
  if (searchParameters.includeLivingElsewhere === false) query.include_living_elsewhere = false
  return query
}

// A response from a previous search must not change the current cards or
// exhaustion state, including when the previous request ends in an error.
async function requestUsers (axios, state, params) {
  const version = state.searchVersion
  try {
    const response = await axios.get('api/users', params)
    return version === state.searchVersion ? response : null
  } catch (error) {
    if (version === state.searchVersion) throw error
    return null
  }
}

export const actions = {
  async fetch ({ commit, state }, searchParameters) {
    commit('START_SEARCH')
    const version = state.searchVersion
    const response = await requestUsers(this.$axios, state, {
      params: searchQuery(searchParameters)
    })
    if (!response || version !== state.searchVersion) return
    commit('SET_USERS', response.data)

    if (response.data.length < 20) {
      commit('SET_NO_MORE_USERS', true)
      return
    }

    commit('SET_NO_MORE_USERS', false)
  },
  async fetchOne ({ commit, state }, searchParameters) {
    const version = state.searchVersion
    const response = await requestUsers(this.$axios, state, {
      params: {
        limit: 1,
        ...searchQuery(searchParameters),
        offset: state.users.length + searchParameters.offsetModifer
      }
    })
    if (!response || version !== state.searchVersion) return
    if (response.data.length === 0) {
      commit('SET_NO_MORE_USERS', true)
      return
    }

    commit('SET_NO_MORE_USERS', false)
    commit('ADD_USER', response.data[0])
  },
  async fetchNew ({ commit, state }, searchParameters) {
    if (state.noMoreUsers) {
      return
    }

    const version = state.searchVersion
    const response = await requestUsers(this.$axios, state, {
      params: {
        ...searchQuery(searchParameters),
        limit: 20,
        offset: state.users.length
      }
    })
    if (!response || version !== state.searchVersion) return

    if (response.data.length === 0) {
      commit('SET_NO_MORE_USERS', true)
      return
    }

    commit('SET_NO_MORE_USERS', false)
    response.data.forEach((user) => {
      commit('ADD_USER', user)
    })
  },
  clear ({ commit }) {
    commit('START_SEARCH')
    commit('SET_USERS', [])
  },
  remove ({ commit, state }, user) {
    if (!state.users.some(existing => existing.id == user.id)) return
    commit('SET_NO_MORE_USERS', false)
    commit('REMOVE_USER', user.id)
  }
}
